










































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { PrintedDocument } from '@/api/model/printed-document'

import { namespace } from 'vuex-class'
const printedDocuments = namespace('printedDocument')

@Component
export default class CompanySettingsEmmaDirectMailPrintedDocumentsList extends Vue {
    @printedDocuments.State readonly loading!: boolean
    @printedDocuments.State readonly printedDocuments!: PrintedDocument[]
    @printedDocuments.State readonly totalItems!: number
    @printedDocuments.State readonly totalPages!: number
    @printedDocuments.State readonly page!: number
    @printedDocuments.State readonly orderField!: string|null
    @printedDocuments.State readonly orderDirection!: string|null
    @printedDocuments.Action applyCompanyFilter: (payload: { query: string }) => Promise<void>
    @printedDocuments.Action nextPage: () => Promise<void>
    @printedDocuments.Action prevPage: () => Promise<void>
    @printedDocuments.Action applyOrder: ({ field, direction }) => Promise<void>

    created() {
        this.onRouteChange()
    }

    @Watch('$route')
    async onRouteChange(): Promise<void> {
        await this.applyCompanyFilter({
            query: this.$currentCompany.id,
        })
    }

    generateHeaderClasses(field: string) {
        return {
            'sortable': true,
            'sorted': this.orderField === field,
            'sorted--asc': this.orderField === field && this.orderDirection === 'asc',
            'sorted--desc': this.orderField === field && this.orderDirection === 'desc',
        }
    }

    changeOrder(field: string, direction: string) {
        if (this.orderField === field) {
            direction = this.orderDirection === 'asc' ? 'desc' : 'asc'
        }

        this.applyOrder({
            field,
            direction,
        })
    }
}
